import * as React from 'react';

export function useMediaQuery(query: string) {
  const [value, setValue] = React.useState(false);

  React.useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return;
    }

    const mql = window.matchMedia(query);
    const onChange = () => setValue(mql.matches);

    setValue(mql.matches);

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }

    // @ts-ignore - addListener exists on older MediaQueryList
    mql.addListener(onChange);
    return () => {
      // @ts-ignore - removeListener exists on older MediaQueryList
      mql.removeListener(onChange);
    };
  }, [query]);

  return value;
}
